module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_num"
  }, [_vm._v("Appendix D")]), _vm._v(" "), _c('h2', {
    staticClass: "chap_title"
  }, [_vm._v("The Composition and Command Cadre of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Front")]), _vm._v("  of Reserve Armies, 14 July 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FRONT")]), _vm._v("  OF RESERVE ARMIES")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commander")]), _vm._v(" – Lieutenant General Ivan Aleksandrovich Bogdanov")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commissar")]), _vm._v(" – Commissar for State Security 3rd Rank S. N. Kruglov")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chief of Staff")]), _vm._v(" – Major General P. I. Liapin")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Formed to control reserve armies in the second defensive belt. Required to occupy positions along the Staraia Russa, Ostashkov, Belyi, Istomino, El’nia, and Briansk line by day’s end on 14 July 1941 and prepare for a firm defense, with special attention paid to carefully preparing antitank and antiaircraft defenses.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Mozhaisk from 13 July")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("First Echelon")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("29th Army")]), _vm._v(" – Lieutenant General Ivan Ivanovich Maslennikov, Deputy Peoples’ Commissar for Internal Affairs (NKVD)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Required strength")]), _vm._v(" – five divisions, two corps artillery regiments, three antitank artillery regiments, one fighter aviation regiment, one bomber aviation regiment, and one Il–2 squadron.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Firmly defend the Staraia Russa, Demiansk, and Ostashkov line. Pay special attention to organizing defenses along the Staraia Russa–Bologoe, Kholm–Bologoe, and Ostashkov–Vyshnii Volochek axes.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Boundary on the left")]), _vm._v(" – (incl.) Toropets, (incl.) Selizharovo, and Vyshnii Volochek.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Bologoe")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("30th Army")]), _vm._v(" – Major General Vasilii Afanas’evich Khomenko, former commander of forces in the Ukrainian Border District")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Required strength")]), _vm._v(" – five divisions, one corps artillery regiment, and two antitank artillery regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Firmly defend the Ostashkov, Selizharovo, Olenino, and Vasilevo line. Pay special attention to organizing defenses along the Toropets–Selizharovo– Kalinin and Velikie Luki–Rzhev–Volokolamsk axes.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Boundary on the left")]), _vm._v(" – Il’ino, (incl.) Nikishino, and Volokolamsk.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Rzhev")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("24th Army")]), _vm._v(" – Major General Stepan Andrianovich Kalinin, the former commander of the Siberian Military District (replaced in late July by Major General Konstantin Ivanovich Rakutin, former commander of forces in the Baltic Border District)")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Required strength")]), _vm._v(" – ten divisions, three gun, one howitzer, and three corps artillery regiments, and four antitank artillery regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Firmly defend the Belyi, Izdeshkovo Station, Dorogobuzh, and El’nia line. Pay special attention to organizing defenses along the Iartsevo–Viaz’ma axis.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Boundary on the left")]), _vm._v(" – Pochinok, Barsuki, (incl.), the sawmill, Butyrlino, and (incl.) Medyn’.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Viaz’ma")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("28th Army")]), _vm._v(" – Major General V. Ia. Kachalov, the former commander of the Arkhangel’sk Military District")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Required strength")]), _vm._v(" – nine divisions, one gun, one howitzer, and four corps artillery regiments, and four antitank artillery regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Missions")]), _vm._v(" – Firmly defend the Desna River line from Logachevo to Zhukovka, Vysokoe, Sosnovka, and Sinezerki. Pay special attention to organizing defenses along Roslavl’–Medyn’ axis and in the Briansk region. Keep the army’s reserve, consisting of four divisions, three of them tank, in the Zanoznaia Station and Kirov region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Kirov")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Front")]), _vm._v("  Reserve")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("31st Army")]), _vm._v(" – Major General Vasilii Nikitich Dalmatov, former chief of the Karelian NKVD Border Military District")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Required strength")]), _vm._v(" – six divisions, one corps artillery regiment, and two antitank artillery regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Have five rifle divisions, one tank division, one corps artillery regiment, and two antitank artillery regiments in the Torzhok, Rzhev, Volokolamsk, and Kalinin region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Staritsa")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("32nd Army")]), _vm._v(" – Lieutenant General Nikolai Kuz’mich Klykov, former deputy commander of the Moscow Military District for Training")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Required strength")]), _vm._v(" – seven divisions and one antitank artillery regiment.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mission")]), _vm._v(" – Have six rifle divisions, one tank division, and one antitank artillery regiment in the Ruza, Mozhaisk, Maloiaroslavets, Vysokinichi, and Naro– Fominsk region.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Headquarters")]), _vm._v(" – Naro–Fominsk")]), _vm._v(" "), _c('p', {
    staticClass: "noindentst"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Source")]), _vm._v(": “Prikaz Stavki VK No. 00334 o sozdanii fronta rezervnykh armii [Stavka VK order no. 00334 about the creation of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Front")]), _vm._v(" of Reserve Armies], in V. A. Zolotarev, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Russkii arkhiv: Velikaia Otechestvennaia [voina]: Dokumenty i materialy. 1941 god., T. 16 (5–1)")]), _vm._v(" [The Russian archives: The Great Patriotic [[War]]: Documents and materials. 1941, Vol. 16 (5–1)] (Moscow: “TERRA,” 1996], 70–72. Hereafter cited as Zolotarev, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stavka")]), _vm._v(" 1941,” with appropriate order and page(s).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6000d938","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/14_Chapter_4.vue
// module id = 99
// module chunks = 0